import {
  Badge,
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Layout,
  List,
  Space,
  Typography,
} from "antd";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import file from "../components/download/authorization-form.pdf";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";

const { Title } = Typography;

const DownloadLink = () => {
  const { theme } = useContext(ThemeContext)
  return (
    <a className={`${theme}-color`} href={file} download={true} size="small">
      HIPAA Authorization
    </a>
  );
};

const PartyRequest = () => {

  const { Content, Footer, Header } = Layout;
  const [value, setValue] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const current = 0;

  const next = () => {
    form.validateFields();
  };

  const onhandlerequest = (requesturl) => {
    if (value) {
      navigate(requesturl);
    }
  };
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            List: {
              fontSize: 24,
              lineWidth: "0",
            },
          },
        }}
      >
        {" "}
        <Layout className="bg-white">
         <CustomHeader />
          <Content className="p-8">
            <Form form={form}>
              <div className="container mx-auto followingl-list">
                <List
                  size="small"
                  header={
                    <Title level={3}>
                      The following information will be required to complete the
                      form:
                    </Title>
                  }
                  footer={
                    <i className="text-base">
                      Please note: There <u>may</u> be a <u>fee</u> for processing your
                      request. If there is a fee, we will reach out to <u>you</u> with
                      the next steps.
                    </i>
                  }
                  bordered={false}
                // dataSource={data}
                >
                  <List.Item className="followingl-list-item">
                    <Typography.Text>
                      <Badge color="black" style={{ marginTop: "-1rem" }} />
                    </Typography.Text>
                    <span>
                      Patient's name and Date of Birth.
                    </span>
                  </List.Item>
                  <List.Item className="followingl-list-item">
                    <Typography.Text>
                      <Badge color="black" style={{ marginTop: "-1rem" }} />
                    </Typography.Text>
                    <span>
                      Completed <u><DownloadLink /></u> form (click on the link to download a blank form).
                    </span>
                  </List.Item>
                </List>
                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(
                            new Error("Please accept the agreement.")
                          ),
                    },
                  ]}
                >
                  <Space className="w-full">
                    {" "}
                    <Checkbox
                      className="font-medium"
                      onChange={() => setValue(!value)}
                    >
                      I have <span className="highlight-color"> all </span>the
                      required information to continue to the form.
                    </Checkbox>
                  </Space>
                </Form.Item>

                <Space className="w-full mt-8 gap-[20px] md:gap-[100px] flex flex-col md:flex-row justify-center">
                  <Button
                    type="primary"
                    // size="large"
                    className="text-[20px] p-6 w-[220px]"
                    onClick={() => {
                      current === 0 ? form.submit() : next()
                      onhandlerequest("/Singlerequest");
                    }}
                  >
                    Single Request
                  </Button>
                  <Button
                    type="primary"
                    // size="large"
                    className="text-[20px] p-6 w-[220px]"
                    onClick={() => {
                      current === 0 ? form.submit() : next()
                      onhandlerequest("/Bulkrequest");
                    }}
                  >
                    Bulk Request
                  </Button>
                </Space>

                <Space className="w-full mt-8 justify-between">
                  <Link to="/Welcome">
                    <Button type="primary" >
                      Back
                    </Button>
                  </Link>
                </Space>
              </div>
            </Form>
          </Content>
        </Layout>
        <Footer className="welcome-footer bg-white">
          <img
            className="m-auto"
            src={window.location.origin + "/assets/images/Logo.png"}
          />
        </Footer>
      </ConfigProvider>
    </>
  );
};

export default PartyRequest;
